module.exports = __webpack_public_path__ + "static/media/animal-dog.f29054fe.png";